module.exports = __webpack_public_path__ + "img/t2-c22.9ceb76df.png";